<template>
  <div class="message">
    <div class="message-row  container">
      <div class="banner">
        <el-carousel height="400px">
          <el-carousel-item v-for="item in bannerList.filter(item => item.link)" :key="item.id">
            <!-- <h3 class="small">{{ item.id }}</h3> -->
            <a :href="item.link" target="_blank">
               <img :src="item.image_url" :alt="item.title"/>
            </a>
            <div class="banner-info">{{ item.title }}</div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div>
        <div style="display: flex; justify-content: space-between; align-items: end;">
          <h1 class="title">最新资讯&nbsp;</h1>
          <router-link class="router-news" to="/news">查看更多 ></router-link>
        </div>
        <ul class="news">
          <li v-for="(item,index) in articleList.slice(0, 5)"
              :key="index" @click="pushNewsView(item.id)"
              data-aos="fade-left" :data-aos-duration="1500">
            <a href="javascript:void(0)" class="news-a" v-if="index === 0">
              <div class="news-text">
                <p class="news-title">{{ item.title }}</p>
                <p class="news-info">{{ item.description }}</p>
                <p class="news-time">{{ item.created_time.split('T')[0] }}</p>
              </div>
            </a>
            <a href="javascript:void(0)" class="news-a" v-else>
              <p class="news-title">{{ item.title }}</p>
              <p class="news-time">{{ item.created_time.split('T')[0] }}</p>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Message",
  data() {
    return {
      articleList: [],
      bannerList: [],
    }
  },
  methods: {
    /**
     * 请求文章列表
     */
    getArticleList() {
      this.$api.reqArticleList(this.articleParams).then(results => {
        if (results.status === 200) {
          this.articleList = results.results
        } else {
          Promise.reject('error')
        }
      }).catch(() => {
        this.$message({showClose: true, message: "新闻列表请求失败！", type: "error"})
      })
    },


    /**
     * 请求轮播图列表
     */
    async getBannerList() {
      let results = await this.$api.reqBannerList()

      if (results.status === 200) {
        this.bannerList = results.results
      } else {
        this.$message({showClose: true, message: "广告轮播数据请求失败！", type: "error"})
      }
    },

    /**
     * 点击文章标题进行跳转
     * @param id 文章id
     */
    pushNewsView(id) {
      console.log(id)
      this.$router.push(`/article/${id}`)
    },
  },
  mounted() {
    this.getArticleList()
    this.getBannerList()
  }
}
</script>

<style scoped lang="less">
.message {
  .message-row {
    display: flex;

    .banner {
      flex: 1;
      box-sizing: border-box;
      margin: 10px 10px 10px 0;
      height: 400px;
      border-radius: 10px;
      overflow: hidden;

      img {
        display: block;
        margin: 0 auto;
        max-width: 100%;
        height: auto;
      }

      .banner-info {
        position: absolute;
        padding: 0 15px;
        width: 100%;
        height: 50px;
        bottom: 0;
        background-color: rgba(0,0,0,0.3);
        font-size: 16px;
        line-height: 45px;
        color: white;
        z-index: 2;
      }

      /deep/ .el-carousel__indicators {
        z-index: 3;
      }
    }

    .title {
      display: inline-block;
      margin: 30px 0 0 20px;
      border-bottom: 2px solid black;
      color: #1E55AE;
    }

    .router-news {
      margin-right: 25px;
      text-decoration: underline;
      font-size: 14px;
      cursor: pointer;

      &:hover {
        color: #3E88F1;
      }
    }

    .news {
      box-sizing: border-box;
      padding: 12px 0 0 20px;
      width: 600px;
      color: #333333;
      line-height: 35px;

      .line-feed() {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }

      .news-a {
        display: flex;
        justify-content: space-between;
        line-height: 50px;
      }

      .news-title {
        font-size: 16px !important;
        color: #333333;
        .line-feed();

        &:hover {
          color: #1E50AE;
          text-decoration: underline;
        }
      }

      .news-info {
        width: 450px;
        font-size: 14px;
        color: #999999;
        .line-feed()
      }

      .news-time {
        width: 100px;
        font-size: 14px;
        color: #999999;
      }

      .news-text {
        width: 480px;
        height: 146px;
      }

      li {
        height: 50px;
        border-top: 1px solid #F0F0F0;

        &:first-child {
          margin-bottom: 25px;
          height: 100px;
          border: none;

          p {
            height: 35px;
          }
        }

        a {
          .news-title {
            width: 400px;
          }
        }
      }
    }
  }
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 44px;
  opacity: 0.75;
  line-height: 400px;
  margin: 0;
  text-align: center;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}
</style>
